import { useState } from 'react';

/**
 * 下注状态管理Hook
 * 管理卡片翻转状态、下注金额和下注逻辑
 */
export function useBettingState() {
  // 只允许一张卡片翻转：记录当前翻转的period.minutes，null为都未翻转
  const [flippedCard, setFlippedCard] = useState(null);
  
  // 下注金额状态
  const [predictAmounts, setPredictAmounts] = useState({
    5: 100,
    15: 100,
    30: 100
  });

  // 处理卡片翻转
  const handleCardClick = (periodMinutes) => {
    setFlippedCard(prev => prev === periodMinutes ? null : periodMinutes);
  };

  // 处理金额输入
  const handleAmountChange = (periodMinutes, value) => {
    setPredictAmounts(prev => ({
      ...prev,
      [periodMinutes]: parseFloat(value) || 0
    }));
  };

  // 处理下注
  const handlePredict = (periodMinutes, getCountdownData, symbol, direction, lastPrice) => {
    const data = getCountdownData(periodMinutes);
    const predictData = {
      symbol,
      direction,
      period: periodMinutes,
      amount: predictAmounts[periodMinutes],
      odds: data.odds,
      currentPrice: lastPrice,
      remainingTime: data.totalSeconds
    };
    console.log('Placing bet:', predictData);
    // TODO: 实际下注逻辑
  };

  return {
    flippedCard,
    predictAmounts,
    handleCardClick,
    handleAmountChange,
    handlePredict
  };
}
